import React from 'react';

export const UpdateSuccessfullyIcon = () => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="60"
    height="60"
    viewBox="0 0 60 60"
    fill="none"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M47 30C47 39.3888 39.3888 47 30 47C20.6112 47 13 39.3888 13 30C13 20.6112 20.6112 13 30 13C39.3888 13 47 20.6112 47 30ZM51 30C51 41.598 41.598 51 30 51C18.402 51 9 41.598 9 30C9 18.402 18.402 9 30 9C41.598 9 51 18.402 51 30ZM41.5388 25.2779C42.2445 24.4282 42.1278 23.1672 41.2781 22.4615C40.4285 21.7557 39.1675 21.8724 38.4618 22.7221L27.7661 35.5991L22.6936 27.5276C22.1059 26.5924 20.8713 26.3107 19.9361 26.8985C19.0008 27.4862 18.7192 28.7208 19.3069 29.656L24.3794 37.7275C25.8275 40.0318 29.1042 40.2485 30.8431 38.1549L41.5388 25.2779Z"
      fill="#82C2A5"
    />
  </svg>
);
